/**
* @fileOverview util - a collection of JavaScript utilities
* @author Matt Begent
* @version 1.0.0 
*/

var util = (function (window, document) {

    'use strict';
 
    return {

        createCookie: function(name, value, days) {

            var expires = "";

            if (days) {
                var date = new Date();
                date.setTime(date.getTime()+(days*24*60*60*1000));
                expires = "; expires="+date.toGMTString();
            } 

            document.cookie = name+"="+value+expires+"; path=/";

        },
 
        getCookie: function(name) {

            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;

        },

        deleteCookie: function(name) {

            u.createCookie(name,"",-1);

        },

        getParameterByName: function(name) {

            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                results = regex.exec(location.search);
            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));

        },

        debounce: function(fn, delay) {

            var timer = null;
            
            return function () {
                var context = this;
                var args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    fn.apply(context, args);
                }, delay);
            };

        },

        template: function (templateMarkup, data) {

            for (var object in data)
                templateMarkup = templateMarkup.replace(new RegExp("{{" + object + "}}", "gi"), data[object]);
            return templateMarkup;

        },

        viewportWidth: function() {

            return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        },

        viewportHeight: function() {
            return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        },

        log: function(e) {
    
            if (window.console && window.console.log) {
                window.console.log(e);
            }

        },

        loadJS: function(src) {
            var script = document.createElement('script');
            script.src = src;
            document.body.appendChild(script);
        },

        cssPropertyValueSupported: function(prop, value) {
            var d = document.createElement('div');
            d.style[prop] = value;
            return d.style[prop] === value;
        }

    };  

})(window, document);  